import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useFetch } from "../../hooks/api_hook";
var token;
const Signup = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("auth_token");
  const [formField, setFormField] = useState({
    phone: "",
    otp: "",
    userName: "",
    checkbox: 0,
  });
  const { data: users } = useFetch("/auth/users");

  const handleChangeFormField = (e) => {
    let { name, value } = e.target;
    if (name === "phone" || name === "otp") {
      value = value.replace(/[^0-9]/g, "");
    }
    setFormField({ ...formField, [e.target.name]: value });
  };

  const RegisterSendOtp = async (event) => {
    try {
      event.preventDefault();
      if (formField.phone.length == 10) {
        const userExists = users?.some(
          (item) => item?.phone === formField.phone
        );
        if (!userExists) {
          const { data } = await axios.post(
            process.env.REACT_APP_BASE_URL + "auth/sendOtp",
            {
              phone: formField.phone,
            }
          );
          token = data.token;
          console.log(token);
          if (data.success) {
            console.log("optp send");
            // toast.success("OTP Sent successfully", {
            //   position: "bottom-right",
            //   autoClose: 8000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "dark",
            // });
          }
        } else {
          // toast.error("User already exists", {
          //   position: "bottom-right",
          //   autoClose: 8000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "dark",
          // });
        }
      } else {
        // toast.error("Please enter a valid phone number", {
        //   position: "bottom-right",
        //   autoClose: 8000,
        //   pauseOnHover: true,
        //   draggable: true,
        //   theme: "dark",
        // });
      }
    } catch (error) {
      // toast.error(`${error.response.data.message}`, {
      //   position: "bottom-right",
      //   autoClose: 8000,
      //   pauseOnHover: true,
      //   draggable: true,
      //   theme: "dark",
      // });
    }
  };

  const onSignUp = async (event) => {
    try {
      console.log("click");
      event.preventDefault();
      if (token) {
        const { data } = await axios.post(
          process.env.REACT_APP_BASE_URL + "auth/verifyOtp",
          {
            otp: formField.otp,
            token: token,
          }
        );
        if (data.success) {
          const { data } = await axios.post(
            process.env.REACT_APP_BASE_URL + "auth/signup",
            {
              phone: formField.phone,
              userName: formField.userName,
              email: formField.email,
            }
          );
          if (data.success) {
            localStorage.setItem("auth_token", token);
            localStorage.setItem("user_id", data.data._id);
            alert("login success");
            navigate("/login");
            if (formField.checkbox == 0) {
              forgotOnClose();
            }
          } else {
            // toast.error(data.message, {
            //   position: "bottom-right",
            //   autoClose: 8000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "dark",
            // });
          }
        } else {
          // toast.error(data.message, {
          //   position: "bottom-right",
          //   autoClose: 8000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "dark",
          // });
        }
      } else {
        // toast.error("Please enter a valid OTP", {
        //   position: "bottom-right",
        //   autoClose: 8000,
        //   pauseOnHover: true,
        //   draggable: true,
        //   theme: "dark",
        // });
      }
    } catch (error) {
      // toast.error(`${error.response.data.message}`, {
      //   position: "bottom-right",
      //   autoClose: 8000,
      //   pauseOnHover: true,
      //   draggable: true,
      //   theme: "dark",
      // });
    }
  };

  const forgotOnClose = () => {
    window.onbeforeunload = function (e) {
      localStorage.clear();
    };
  };

  const handleCheckBox = (e) => {
    const { value, checked } = e.target;
    setFormField({ ...formField, [value]: checked ? 1 : 0 });
  };

  return (
    <>
      <div className="auth">
        <div className="div sign_up">
          <div className="div-8">
            <div className="div-9 d-flex flex-row">
              <div className="column-2">
                <span className="span-5">
                  <div className="div-13">Register</div>

                  <span className="span-6">
                    <div className="div-14" />

                    <div className="div-15">
                      <input
                        type="text"
                        name="userName"
                        onChange={handleChangeFormField}
                        placeholder="Enter your Full Name"
                      />
                    </div>
                  </span>

                  <span className="span-6">
                    <div className="div-14" />

                    <div className="div-15">
                      <input
                        type="tel"
                        name="phone"
                        onChange={handleChangeFormField}
                        placeholder="Enter your phone number"
                        maxLength={10}
                      />
                      <button className="button_otp" onClick={RegisterSendOtp}>
                        Generate otp
                      </button>
                    </div>
                  </span>

                  <span className="span-6">
                    <div className="div-16" />
                    <div className="div-17">
                      <input
                        type="tel"
                        name="otp"
                        onChange={handleChangeFormField}
                        placeholder="Enter OTP"
                      />
                    </div>
                  </span>
                  {/* <div className="checkbox">
                    <input
                      type="checkbox"
                      width={20}
                      height={20}
                      onChange={handleCheckBox}
                      style={{ marginRight: "5px" }}
                    />
                    Keep me signed in
                  </div> */}

                  <button className="span-9" onClick={onSignUp}>
                    Register
                  </button>

                  <div className="div-20">
                    <span className="register-text">Already a user? </span>
                    <Link className="create-account-text" to="/login">
                      Login
                    </Link>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default Signup;
